export type PlainObject = Record<string, unknown>

/**
 * A data object and nothing else — not an array, not a class instance, not `null`.
 *
 * The prototype is compared rather than `typeof`: everything this segment walks (a filter
 * tree out of the URL, a form's nested attributes) is either a literal or a `Date`, an
 * `File` or a `RegExp` that has to be left whole, and `typeof x === 'object'` waves all
 * three through into a recursion that flattens them.
 */
export function isPlainObject(value: unknown): value is PlainObject {
  return (
    typeof value === 'object' &&
    value !== null &&
    !Array.isArray(value) &&
    Object.getPrototypeOf(value) === Object.prototype
  )
}
